/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecentlyVisited } from '../../models/recently-visited';

export interface RecentlyVisitedGetRecentlyVisitedPatientRecords$Params {
  PracticeId?: string | null;
}

export function recentlyVisitedGetRecentlyVisitedPatientRecords(http: HttpClient, rootUrl: string, params?: RecentlyVisitedGetRecentlyVisitedPatientRecords$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RecentlyVisited>>> {
  const rb = new RequestBuilder(rootUrl, recentlyVisitedGetRecentlyVisitedPatientRecords.PATH, 'get');
  if (params) {
    rb.query('PracticeId', params.PracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RecentlyVisited>>;
    })
  );
}

recentlyVisitedGetRecentlyVisitedPatientRecords.PATH = '/getRecentlyVisitedPatientRecords';
